import React, { useEffect, useState } from "react";
import { sortBy, groupBy } from "lodash";

import { SelectChangeEvent, Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";

import { CategoryCard, FilterBox, ModeCard, VariableCard, VariableGroupCard } from "@/components/atoms";
import { useInsightFilters } from "@/context";
import { InsightResult, TitleGenres } from "@/types";
import { tvOptions } from "@/utils";


interface UsageViewProps {
  scores: InsightResult[];
}


export const SportsView: React.FC<UsageViewProps> = ({ scores }) => {
  const {
    filters: { scoreType },
  } = useInsightFilters();

  const [minMax, setMinMax] = useState<number[]>([0, 1]);

  useEffect(() => {
    const maxScore = Math.max.apply(
      Math,
      scores
        .filter((x) => x.tag_name !== x.tag_category)
        .map((x) => Number(x[scoreType.value as keyof InsightResult])),
    );
    const minScore =
      scoreType.value === "rate"
        ? Math.min.apply(
          Math,
          scores
            .filter((x) => x.tag_name !== x.tag_category)
            .map((x) => Number(x[scoreType.value as keyof InsightResult])),
        )
        : Math.max(1 - (maxScore - 1), 0);

    setMinMax([minScore, maxScore])
  }, [scores, scoreType])

  return (
    <>
      {Object.entries(groupBy(scores, 'tag_category')).map((category, idx) => (
        <Grid size={12} key={category[0]}>
          <Stack spacing={1} sx={{ mb: 1 }}>
            <Typography>{category[0]}</Typography>
            <Grid container size={12} spacing={1}>
              {category[1].map((variable, variableIdx) => (
                <Grid key={`${category[0]}-${variableIdx}`}>
                  <VariableCard
                    name={variable.tag_name}
                    value={Number(variable[scoreType.value as keyof InsightResult])}
                    score={scoreType.value}
                    minValue={minMax[0]}
                    maxValue={minMax[1]}
                  />
                </Grid>
              ))}
            </Grid>
          </Stack>
        </Grid>
      ))}
    </>
  );
};

export default SportsView;
